<template>
  <div>
    <service-header :signedIn="signedInUser !== null"/>
    <b-container>
      <b-row>
        <b-col cols="12">
          <div class="thanks-wrapper">
            <h1 class="heading">会議室のご利用ありがとうございました。</h1>
            <div class="button-wrapper">
              <proa-service-button
                variant="primary square"
                text="会議室に再入室"
                @click.native="onClickReEnter"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <service-footer
      :signedIn="signedInUser !== null"
      :route="$route.name"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ServiceHeader from '@/components/molecules/service/ServiceHeader.vue'
import ServiceFooter from '@/components/molecules/service/ServiceFooter.vue'

export default {
  name: 'ServiceThanks',
  components: {
    ServiceHeader,
    ServiceFooter
  },
  computed: {
    guestToken: function() { return this.$route.params.guestToken },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  methods: {
    onClickReEnter: function() {
      this.$router.push({
        name: 'guestMeeting',
        query: {
          token: this.guestToken
        }
      })
    }
  },
  created() {
    if (!this.guestToken) {
      this.$router.push({ name: 'service' })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";

.thanks-wrapper {
  padding: 80px 0 50px 0;
  font-size: 14px;
  line-height: 1.8em;

  @include mq(md) {
    padding: 130px 0 50px 0;
    font-size: 16px;
  }

  .heading {
    text-align: center;
    font-size: 1.5em;
    font-weight: 600;
    line-height: 1.3em;
    margin-bottom: 60px;

    @include mq(md) {
      font-size: 2em;
    }
  }
}

.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
}
</style>
